module.exports = __webpack_public_path__ + "img/slide10_vn.b453c904.jpg";